export default "__VITE_ASSET__Yek55Y1I__"